import {MenuOutlined, DragOutlined} from '@ant-design/icons';
import {
    arrayMove,
} from '@dnd-kit/sortable';
import React, {useEffect, useState} from 'react';
import {DragSortTable} from '@ant-design/pro-components';


export default function SortableTable(props) {
    const [dataSource, setDataSource] = useState(props.dataSource);

    const onDragEnd = (newDataSource) => {
        //console.log(newDataSource)
        setDataSource(newDataSource)
        props.onSortChange(newDataSource)
    };

    useEffect(() => {
        setDataSource(props.dataSource)
    }, [props.dataSource])

    return (
        <DragSortTable
            search={false}
            options={{fullScreen: false, reload: false, setting: false, density: false}}

            rowKey="id"
            dragSortKey="sort"
            onDragSortEnd={onDragEnd}
            columns={[{title: <DragOutlined/>, key: "sort", align: "center"}, ...props.columns]}
            dataSource={dataSource}
            bordered={false}
            loading={props.loading}
            pagination={false}
        />
    );
};
